/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Dashfix_Error_Durable_FailedInputs */

const en_dashfix_error_durable_failed = /** @type {(inputs: Dashfix_Error_Durable_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Durable request failed: ${i?.code}`)
};

const zh_hans1_dashfix_error_durable_failed = /** @type {(inputs: Dashfix_Error_Durable_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`异步请求失败：${i?.code}`)
};

const pt_br2_dashfix_error_durable_failed = /** @type {(inputs: Dashfix_Error_Durable_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A requisição assíncrona falhou: ${i?.code}`)
};

const es_dashfix_error_durable_failed = /** @type {(inputs: Dashfix_Error_Durable_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La solicitud asíncrona falló: ${i?.code}`)
};

const fr_dashfix_error_durable_failed = /** @type {(inputs: Dashfix_Error_Durable_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de la requête durable : ${i?.code}`)
};

const de_dashfix_error_durable_failed = /** @type {(inputs: Dashfix_Error_Durable_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Persistente Anfrage fehlgeschlagen: ${i?.code}`)
};

const ru_dashfix_error_durable_failed = /** @type {(inputs: Dashfix_Error_Durable_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Устойчивый запрос завершился ошибкой: ${i?.code}`)
};

const it_dashfix_error_durable_failed = /** @type {(inputs: Dashfix_Error_Durable_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Richiesta durevole non riuscita: ${i?.code}`)
};

/**
* | output |
* | --- |
* | "Durable request failed: {code}" |
*
* @param {Dashfix_Error_Durable_FailedInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const dashfix_error_durable_failed = /** @type {((inputs: Dashfix_Error_Durable_FailedInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashfix_Error_Durable_FailedInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_dashfix_error_durable_failed(inputs)
	if (locale === "pt-BR") return pt_br2_dashfix_error_durable_failed(inputs)
	if (locale === "es") return es_dashfix_error_durable_failed(inputs)
	if (locale === "fr") return fr_dashfix_error_durable_failed(inputs)
	if (locale === "de") return de_dashfix_error_durable_failed(inputs)
	if (locale === "ru") return ru_dashfix_error_durable_failed(inputs)
	if (locale === "it") return it_dashfix_error_durable_failed(inputs)
	return en_dashfix_error_durable_failed(inputs)
});